'use client';

import { c as _c } from "react/compiler-runtime";
import { Badge, Button, FilterChip, FiltroPeriodo, IconButton, TextField } from '@/shared/components/ui';
import { FeatherFilter, FeatherPlay, FeatherRotateCcw, FeatherSearch, FeatherUser, FeatherX } from '@subframe/core';
import { ColunasDropdown } from '@/features/negociacaoColunas';
import type { PeriodoValor } from '@/shared/types/filtroPeriodo';
import type { NegociacoesActiveChip, NegociacoesFilters } from '../types/negociacoesUiTypes';
import { periodoCampoOptions } from '../utils/negociacoesFilterOptions';
interface NegotiacoesFiltersBarProps {
  openDrawer: () => void;
  searchInput: string;
  setSearchInput: (value: string) => void;
  activeChips: NegociacoesActiveChip[];
  removeChip: (chip: NegociacoesActiveChip) => void;
  hasActiveFilters: boolean;
  clearAllFilters: () => void;
  filters: NegociacoesFilters;
  toggleFilterValue: (category: keyof NegociacoesFilters, value: string) => void;
  clearFilterCategory: (category: keyof NegociacoesFilters) => void;
  escritorioId?: string;
  periodo: PeriodoValor;
  onAplicarPeriodo: (valor: PeriodoValor) => void;
  onRascunhoPeriodoChange: (valor: PeriodoValor | null) => void;
  resumoPeriodo?: string;
}
export function NegotiacoesFiltersBar(t0) {
  const $ = _c(63);
  const {
    openDrawer,
    searchInput,
    setSearchInput,
    activeChips,
    removeChip,
    hasActiveFilters,
    clearAllFilters,
    filters,
    toggleFilterValue,
    clearFilterCategory,
    escritorioId,
    periodo,
    onAplicarPeriodo,
    onRascunhoPeriodoChange,
    resumoPeriodo
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <FeatherSearch />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== searchInput || $[2] !== setSearchInput) {
    t2 = searchInput ? <IconButton variant="neutral-tertiary" icon={<FeatherX />} onClick={() => setSearchInput("")} size="small" /> : null;
    $[1] = searchInput;
    $[2] = setSearchInput;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== setSearchInput) {
    t3 = e => setSearchInput(e.target.value);
    $[4] = setSearchInput;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== searchInput || $[7] !== t3) {
    t4 = <TextField.Input placeholder={"Buscar negocia\xE7\xE3o..."} value={searchInput} onChange={t3} />;
    $[6] = searchInput;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <div className="w-full min-w-0 sm:min-w-[18rem] sm:flex-1"><TextField variant="outline" icon={t1} iconRight={t2} className="w-full">{t4}</TextField></div>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== onAplicarPeriodo || $[13] !== onRascunhoPeriodoChange || $[14] !== periodo || $[15] !== resumoPeriodo) {
    t6 = <FiltroPeriodo campos={periodoCampoOptions} valor={periodo} onChange={onAplicarPeriodo} onRascunhoChange={onRascunhoPeriodoChange} resumo={resumoPeriodo} />;
    $[12] = onAplicarPeriodo;
    $[13] = onRascunhoPeriodoChange;
    $[14] = periodo;
    $[15] = resumoPeriodo;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <FeatherFilter />;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span className="max-md:text-sm">Mais filtros</span>;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== openDrawer) {
    t9 = <Button variant="neutral-secondary" icon={t7} onClick={openDrawer} className="h-10">{t8}</Button>;
    $[19] = openDrawer;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== escritorioId) {
    t10 = <ColunasDropdown escritorioId={escritorioId} />;
    $[21] = escritorioId;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t6 || $[25] !== t9) {
    t11 = <div className="flex w-full max-w-full flex-wrap items-center gap-3 sm:w-auto">{t6}{t9}{t10}</div>;
    $[23] = t10;
    $[24] = t6;
    $[25] = t9;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t11 || $[28] !== t5) {
    t12 = <div className="flex w-full min-w-0 flex-wrap items-center gap-3 2xl:w-auto 2xl:flex-1">{t5}{t11}</div>;
    $[27] = t11;
    $[28] = t5;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <span className="text-caption font-caption text-subtext-color">Atalhos:</span>;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  const t14 = filters.status.length === 0 ? "brand" : "neutral";
  let t15;
  if ($[31] !== clearFilterCategory) {
    t15 = () => clearFilterCategory("status");
    $[31] = clearFilterCategory;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t14 || $[34] !== t15) {
    t16 = <Badge variant={t14} className="cursor-pointer transition-colors hover:bg-neutral-100" onClick={t15}>Ver todos</Badge>;
    $[33] = t14;
    $[34] = t15;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  const t17 = filters.status.includes("Em negocia\xE7\xE3o") ? "brand" : "neutral";
  let t18;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <FeatherPlay className="text-blue-500" />;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== toggleFilterValue) {
    t19 = () => toggleFilterValue("status", "Em negocia\xE7\xE3o");
    $[37] = toggleFilterValue;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== t17 || $[40] !== t19) {
    t20 = <Badge variant={t17} icon={t18} className="cursor-pointer transition-colors hover:bg-neutral-100" onClick={t19}>Em negociação</Badge>;
    $[39] = t17;
    $[40] = t19;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  const t21 = filters.status.includes("Aguardando interven\xE7\xE3o humana") ? "brand" : "neutral";
  let t22;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <FeatherUser className="text-orange-500" />;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  let t23;
  if ($[43] !== toggleFilterValue) {
    t23 = () => toggleFilterValue("status", "Aguardando interven\xE7\xE3o humana");
    $[43] = toggleFilterValue;
    $[44] = t23;
  } else {
    t23 = $[44];
  }
  let t24;
  if ($[45] !== t21 || $[46] !== t23) {
    t24 = <Badge variant={t21} icon={t22} className="cursor-pointer transition-colors hover:bg-neutral-100" onClick={t23}>Aguardando intervenção humana</Badge>;
    $[45] = t21;
    $[46] = t23;
    $[47] = t24;
  } else {
    t24 = $[47];
  }
  let t25;
  if ($[48] !== t16 || $[49] !== t20 || $[50] !== t24) {
    t25 = <div className="flex min-w-0 flex-wrap items-center gap-2 border-t border-neutral-100 pt-3 2xl:border-0 2xl:pt-0">{t13}<div className="flex min-w-0 flex-wrap items-center gap-1.5">{t16}{t20}{t24}</div></div>;
    $[48] = t16;
    $[49] = t20;
    $[50] = t24;
    $[51] = t25;
  } else {
    t25 = $[51];
  }
  let t26;
  if ($[52] !== t12 || $[53] !== t25) {
    t26 = <div className="flex w-full flex-col gap-3 2xl:flex-row 2xl:items-center 2xl:justify-between">{t12}{t25}</div>;
    $[52] = t12;
    $[53] = t25;
    $[54] = t26;
  } else {
    t26 = $[54];
  }
  let t27;
  if ($[55] !== activeChips || $[56] !== clearAllFilters || $[57] !== hasActiveFilters || $[58] !== removeChip) {
    t27 = activeChips.length > 0 && <div className="flex flex-wrap items-center justify-between gap-4 py-2"><div className="flex flex-wrap items-center gap-2">{activeChips.map((chip, idx) => <FilterChip key={`${chip.category}-${chip.value}-${idx}`} active={true} onClick={() => removeChip(chip)}><div className="flex items-center gap-1.5">{chip.label}<FeatherX className="h-3 w-3" /></div></FilterChip>)}{hasActiveFilters && <Button variant="neutral-tertiary" size="small" onClick={clearAllFilters} icon={<FeatherRotateCcw />}>Limpar filtros</Button>}</div></div>;
    $[55] = activeChips;
    $[56] = clearAllFilters;
    $[57] = hasActiveFilters;
    $[58] = removeChip;
    $[59] = t27;
  } else {
    t27 = $[59];
  }
  let t28;
  if ($[60] !== t26 || $[61] !== t27) {
    t28 = <div className="flex w-full flex-col gap-4">{t26}{t27}</div>;
    $[60] = t26;
    $[61] = t27;
    $[62] = t28;
  } else {
    t28 = $[62];
  }
  return t28;
}